import { useState, useEffect, useContext } from "react";
import AppContext from "../../context";
import css from "./Report.module.css";
import Card from "../../components/Card/Card";
import backgroundCard from "../../assets/images/backgroundCardGreen.png"
import ExcelUtils from "../../utils/excel";
import { AlertEntity } from "../../layouts/Alert/AlertEntity";
import { format } from "date-fns";
import { ReportTappingMakananEntity } from "../../entities/ReportEnity";
import { ReportService } from "../../services/report";
import FilterUtils from "../../utils/filter-utils";
import { VendorPorsiService } from "../../services/vendors_porsi";
import { VendorPorsiEntity } from "../../entities/VendorPorsiEntity";

export default function ReportActualPorsi() {
  // ========================================= GLOBAL CONTEXT =========================================  //
  const context = useContext(AppContext);
  const contextAccessToken = context.contextAccessToken;
  const contextShowAlertFunc = context.contextShowAlertFunc;
  const contextShowLoadingFunc = context.contextShowLoadingFunc;
  const stateShowLoading = context.stateShowLoading
  // ========================================= GLOBAL CONTEXT =========================================  //


  // ========================================= STATE VIEW =========================================  //

  const [tableDataFilter, setTableDataFilter] = useState<{ [key: string]: string }>({});
  const [tableData, setTableData] = useState<VendorPorsiEntity[]>([]);
  const [filterDate, setFilterDate] = useState({
    start_date: format(new Date(), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd")
  });

  // ========================================= STATE VIEW =========================================  //

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  const handleGenerateExcel = async () => {
    if (tableData.length == 0) { return contextShowAlertFunc(new AlertEntity({ message: "NO DATA!", level: 3 })); }
    const column = [
      "tanggal", "shift", "vendor", "lokasi",

      "qty_total_regular", "qty_regular_dropoff", "qty_regular_tapping",
      "qty_regular_guest", "qty_sisa_regular", "qty_terpakai_regular",

      "qty_total_vegetarian", "qty_vegetarian_dropoff", "qty_vegetarian_tapping",
      "qty_vegetarian_guest", "qty_sisa_vegetarian", "qty_terpakai_vegetarian",
    ];
    let values: { [key: string]: string }[] = [];
    let dataForExport = tableData.filter((row) => {
      return FilterUtils.FilterTable(row, tableDataFilter)
    })
    for (let i = 0; i < dataForExport.length; i++) {
      const row = dataForExport[i]
      values.push({
        tanggal: (format(row.tanggal, "yyyy-MM-dd")).toString(),
        shift: row.shift.toString(),
        vendor: row.vendor,
        lokasi: row.lokasi,

        qty_total_regular: row.qty_regular.toString(),
        qty_regular_dropoff: row.taken_regular_dropoff.toString(),
        qty_regular_tapping: row.taken_regular_tapping.toString(),
        qty_regular_guest: row.taken_regular_guest.toString(),
        qty_sisa_regular: row.sisa_regular.toString(),
        qty_terpakai_regular: (row.qty_regular - row.sisa_regular).toString(),

        qty_total_vegetarian: row.qty_vegetarian.toString(),
        qty_vegetarian_dropoff: row.taken_vegetarian_dropoff.toString(),
        qty_vegetarian_tapping: row.taken_vegetarian_tapping.toString(),
        qty_vegetarian_guest: row.taken_vegetarian_guest.toString(),
        qty_sisa_vegetarian: row.sisa_vegetarian.toString(),
        qty_terpakai_vegetarian: (row.qty_vegetarian - row.sisa_vegetarian).toString(),
      })
    }
    ExcelUtils.export(`Tapping List on ${filterDate.start_date} until ${filterDate.end_date}`, column, values);
  }

  const generateData = async () => {
    contextShowLoadingFunc(true);
    try {
      const resp = await VendorPorsiService.GetAllVendorsPorsi(filterDate.start_date, filterDate.end_date);
      setTableData(resp);
      contextShowLoadingFunc(false);
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  };

  useEffect(() => {
    generateData();
  }, [contextAccessToken]);

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  return (
    <>
      <div className="container" style={{ display: stateShowLoading ? "none" : "flex" }}>
        <Card
          detailTitle="Report Actual Porsi"
          detailColor="var(--secondary-color)"
          backgroundImage={backgroundCard}
          stateShow={true}
          detailCard={
            <>
              <div className={css.rowGrid} style={{ alignItems: 'end' }}>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>Start Date :</label>
                  <input style={{ fontSize: "12px" }} type="date" value={filterDate.start_date}
                    onChange={(event) => setFilterDate(prevState => ({
                      ...prevState,
                      start_date: event.target.value
                    }))}
                  />
                </div>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>End Date :</label>
                  <input style={{ fontSize: "12px" }} type="date" value={filterDate.end_date}
                    onChange={(event) => setFilterDate(prevState => ({
                      ...prevState,
                      end_date: event.target.value
                    }))}
                  />
                </div>
                <div>
                  <div style={{ color: "white", textAlign: "left" }}>&nbsp;</div>
                  <button className="cardButton" onClick={() => generateData()} >
                    Refresh
                  </button>
                </div>
                <div>
                  <button className="cardButton" onClick={() => handleGenerateExcel()} >
                    Generate Excel
                  </button>
                </div>
              </div>
              <div className={css.rowGrid} style={{ alignItems: 'end', marginTop: "1vh" }}>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>tanggal :</label>
                  <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                    onChange={(event) => {
                      setTableDataFilter((prev) => ({ ...prev, tanggal: event.target.value }));
                    }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>shift :</label>
                  <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                    onChange={(event) => {
                      setTableDataFilter((prev) => ({ ...prev, shift: event.target.value }));
                    }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>vendor :</label>
                  <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                    onChange={(event) => {
                      setTableDataFilter((prev) => ({ ...prev, vendor: event.target.value }));
                    }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>lokasi :</label>
                  <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                    onChange={(event) => {
                      setTableDataFilter((prev) => ({ ...prev, lokasi: event.target.value }));
                    }}
                  />
                </div>
              </div>
            </>
          }
        />
        <div
          style={{ height: "65vh", overflow: "auto" }}>
          <table className="tableclickcell">
            {tableData.length > 0 ?
              <>
                <thead>
                  <tr>
                    <th rowSpan={2} style={{ backgroundColor: "var(--header-color)" }}>No</th>
                    <th rowSpan={2} style={{ backgroundColor: "var(--header-color)" }}>Tanggal</th>
                    <th rowSpan={2} style={{ backgroundColor: "var(--header-color)" }}>Shift</th>
                    <th rowSpan={2} style={{ backgroundColor: "var(--header-color)" }}>Vendor</th>
                    <th rowSpan={2} style={{ backgroundColor: "var(--header-color)" }}>Lokasi</th>

                    <th colSpan={6} style={{ backgroundColor: "var(--header-color-hover)" }}>QTY Reguler</th>
                    <th colSpan={6} style={{ backgroundColor: "#d87093" }}>QTY Vegetarian</th>
                  </tr>

                  <tr>
                    <th style={{ backgroundColor: "var(--header-color-hover)" }}>Total</th>
                    <th style={{ backgroundColor: "var(--header-color-hover)" }}>Dropoff</th>
                    <th style={{ backgroundColor: "var(--header-color-hover)" }}>Tapping</th>
                    <th style={{ backgroundColor: "var(--header-color-hover)" }}>Guest</th>
                    <th style={{ backgroundColor: "var(--header-color-hover)" }}>Sisa</th>
                    <th style={{ backgroundColor: "var(--header-color-hover)" }}>Terpakai</th>

                    <th style={{ backgroundColor: "#d87093" }}>Total</th>
                    <th style={{ backgroundColor: "#d87093" }}>Dropoff</th>
                    <th style={{ backgroundColor: "#d87093" }}>Tapping</th>
                    <th style={{ backgroundColor: "#d87093" }}>Guest</th>
                    <th style={{ backgroundColor: "#d87093" }}>Sisa</th>
                    <th style={{ backgroundColor: "#d87093" }}>Terpakai</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.filter((row) => {
                    return FilterUtils.FilterTable(row, tableDataFilter)
                  })
                    .map((row, idx) => {
                      return <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td>{format(row.tanggal, "yyyy-MM-dd")}</td>
                        <td>{row.shift}</td>
                        <td>{row.vendor}</td>
                        <td>{row.lokasi}</td>

                        <td>{row.qty_regular}</td>
                        <td>{row.taken_regular_dropoff}</td>
                        <td>{row.taken_regular_tapping}</td>
                        <td>{row.taken_regular_guest}</td>
                        <td>{row.sisa_regular}</td>
                        <td>{(row.qty_regular - row.sisa_regular)}</td>

                        <td>{row.qty_vegetarian}</td>
                        <td>{row.taken_vegetarian_dropoff}</td>
                        <td>{row.taken_vegetarian_tapping}</td>
                        <td>{row.taken_vegetarian_guest}</td>
                        <td>{row.sisa_vegetarian}</td>
                        <td>{(row.qty_vegetarian - row.sisa_vegetarian)}</td>
                      </tr>
                    })}
                </tbody>
              </>
              :
              <>
                <thead><tr><th>no data available yet!</th></tr></thead>
              </>
            }
          </table>
        </div>
      </div>
    </>
  );
}
